import { getImageSize } from '@/utils/fs/image.utils';
import {
  uint8,
  uint16,
  uint32,
  int8,
  int16,
  int32,
  parseVersion,
  saveMap
} from '../utils'; //定义的一些unit函数
import dataItemStyle from './dataItemStyle'; //引入数据源变量
import { Description } from '@/types/watchface';
import { app_id, enumGroupType } from './dataSource';
import { CompressMethod } from './compiler';
import { fmtIndexEnum } from '../pngConvert/fmtEnum';
import pngConvert from '../pngConvert';
import { ElectronApi } from '@/services/electron.api';
import {
  getThemeTableTotalCount,
  getThemePreLength,
  getThemeTableLength,
  THEME_TABLE_PER_ROW_LENGTH,
  THEME_TABLE_PRE_LENGTH,
  RECORD_LENGTH
} from './constant';
const path = ElectronApi.path;
interface SingleTheme {
  name?: string;
  recordsCount: number[];
  recordsIdAdder: number[];
  records: any[];
  datas: any[];
  bgColor?: string;
  isPhotoAlbumWatchface?: string;
  layoutsNum?: number;
  bg?: string;
  colorGroupTable?: string;
  type?: string;
  fg?: string;
  fgUid?: Buffer;
}

interface ThemeData {
  [key: string]: SingleTheme;
}
let HEADER_LENGTH = 168; // header长168个字节，v6.0.3增加64个字节  增加了recolorTable 4

const LAYOUT_DATA_PRE_LENGTH = 16;
const IMG_DATA_PRE_LENGTH = 12;
const IMG_ARRY_DATA_PRE_LENGTH = 12;
const SPRITE_SIMPLE_DATA_PRE_LEENGTH = 12;
const DATA_ITEM_POINTER_DATA_PER_LENGTH = 32;
const DATA_ITEM_IMAGE_VALUES_PRE_LENGTH = 16;
const DATA_ITEM_IMAGE_NUMBER_PRE_LENGTH = 20;
const DATA_ITEM_ARC_PROGRESS_BAR_INDICATOR_PRE_LENGTH = 52;
const DATA_ITEM_LINE_PROGRESS_BAR_INDICATOR_PRE_LENGTH = 52;
const WIDGET_PRE_LENGTH = 44;
const SLOT_PRE_LENGTH = 4;

const LAYOUT = 0x00,
  IMG = 0x02,
  IMG_ARRAY = 0x03,
  SPRITE = 0x04,
  DATA = 0x07,
  SLOT = 0x08,
  WIDGET = 0x09;

const originData: any[] = [];
const resourcesData: any = {}; // 存放解析后的xml数据

const themePreview = new Map<string, any>();
const themeData: ThemeData = {
  normal: {
    recordsCount: new Array(getThemeTableTotalCount()).fill(0),
    recordsIdAdder: new Array(getThemeTableTotalCount()).fill(0),
    records: [],
    datas: [],
    layoutsNum: 0
  },
  AOD: {
    recordsCount: new Array(getThemeTableTotalCount()).fill(0),
    recordsIdAdder: new Array(getThemeTableTotalCount()).fill(0),
    records: [],
    datas: [],
    layoutsNum: 0
  }
};

const resetThemeData = () => {
  Object.keys(themeData).forEach((key) => {
    themeData[key] = {
      recordsCount: new Array(getThemeTableTotalCount()).fill(0),
      recordsIdAdder: new Array(getThemeTableTotalCount()).fill(0),
      records: [],
      datas: [],
      layoutsNum: 0
    };
  });
};

export async function m65m66XmlConvert(
  ast: Ast,
  basicInfo: Description,
  resourcePath: string
): Promise<Buffer> {
  resetThemeData();
  const watchface = ast;
  let isAOD = false;
  //如果有多颜色每个颜色占4位，头的长度要增加相应的长度
  const { compressMethod, editable } = ast.attrsMap;
  if (watchface.attrsMap.recolorTable && HEADER_LENGTH == 168) {
    HEADER_LENGTH =
      HEADER_LENGTH + watchface.attrsMap.recolorTable.split(',').length * 4;
  }
  const isEditable = editable === 'true';
  // 初始化resourcesData
  for (const element of watchface.children) {
    if (element.tag === 'Resources') {
      const resources = element.children;
      for (const resource of resources) {
        let data: any = {};
        if (resource.tag === 'Image') {
          if (resource.attrsMap.src) {
            data = await genImageData(resource, resourcePath, compressMethod);
          }
          //如果解析到图片，进行压缩和图片格式的处理
          //data里面的imgData为压缩后的数据
        } else if (resource.tag === 'ImageArray') {
          data = await genImageArrayData(
            resource,
            resourcePath,
            compressMethod
          );
        } else if (resource.tag === 'Sprite') {
          data = genSimpleData(resource, SPRITE);
        } else if (resource.tag === 'DataItemImageValues') {
          data = genDataItemValuesData(resource);
        } else if (resource.tag === 'DataItemImageNumber') {
          data = genSimpleData(resource, DATA);
        } else if (resource.tag === 'DataItemPointer') {
          data = genSimpleData(resource, DATA);
        } else if (resource.tag === 'DataItemArcProgressBar') {
          data = genSimpleData(resource, DATA);
        } else if (resource.tag === 'DataItemLineProgressBar') {
          data = genSimpleData(resource, DATA);
        } else if (resource.tag === 'Widget') {
          //fq 对Widget进行处理
          data = genWidgetData(resource);
        } else if (resource.tag === 'Slot') {
          data = genSlotData(resource);
        }
        resourcesData[data.name] = data;
      }
    } else if (element.tag === 'Theme') {
      const layouts = element.children; //获取到theme底下的layouts，为数组
      if (element.attrsMap.type === 'AOD' && layouts.length > 0) {
        //说明有AOD
        isAOD = true;
      }
      const bgHackLayout = [];
      if (layouts.length > 0) {
        const { bg, bgColor, preview, type, isPhotoAlbumWatchface } =
          element.attrsMap;
        themeData[type].layoutsNum = layouts.length;
        if (bg) {
          const hasBgLayout = layouts.some(
            (layout: any) => layout.attrsMap.ref === bg
          );
          if (!hasBgLayout) bgHackLayout.push({ attrsMap: { ref: bg } });
        } else if (bgColor) {
          themeData[type].bgColor = bgColor;
        }
        if (preview) {
          // mark resource as theme preview img
          Object.entries(resourcesData).forEach(
            ([_, resource]: [string, any]) => {
              if (resource.name === preview.slice(1)) {
                resource.preview = true;
                // in case that two themes refer the same preview img
                if (!resource.themeType) {
                  resource.themeType = [type];
                } else {
                  resource.themeType.push(type);
                }
              }
            }
          );
        }
        // 是否相册表盘
        if (isPhotoAlbumWatchface && type === 'normal') {
          themeData[type].isPhotoAlbumWatchface = isPhotoAlbumWatchface;
        }
        const layoutsWithBg = [...bgHackLayout, ...layouts];
        if (type.includes('normal') && type === 'normal') {
          layoutsWithBg.forEach((layout) => {
            const data = genLayoutData(layout);
            resourcesData[`normal-layout-${data.ref}-${data._id}`] = data;
          });
        } else if (type.includes('normal') && type !== 'normal') {
          layoutsWithBg.forEach((layout) => {
            const data = genLayoutData(layout);
            resourcesData[`${type}-layout-${data.ref}-${data._id}`] = data;
          });
        } else if (type === 'AOD') {
          layoutsWithBg.forEach((layout) => {
            const data = genLayoutData(layout);
            resourcesData[`AOD-layout-${data.ref}-${data._id}`] = data;
          });
        }
      }
    }
  }
  let dataAddressOffset = 0;
  //每个theme的layout单独计算和记录偏移地址
  let layoutAddressOffset = 0;
  //layoutRecordCount记录每个theme中的layout，遍历完成一个theme后归零计算下一个theme
  let layoutRecordCount = 0;
  Object.entries(resourcesData).forEach(([key, value]: [string, any]) => {
    if (value.type === IMG && value.preview) {
      const {
        height,
        width,
        imgData,
        themeType,
        name,
        fmtIndex,
        compressMethod
      } = value;
      const resourceData = {
        type: IMG,
        height,
        width,
        imgData,
        dataLength: imgData.length,
        totalLength: IMG_DATA_PRE_LENGTH + imgData.length,
        dataAddr: dataAddressOffset,
        themeType,
        compressMethod,
        fmtIndex: fmtIndex
      };
      themeType.forEach((type: string) => themePreview.set(type, resourceData));

      originData.push(resourceData);
      dataAddressOffset += resourceData.totalLength || 0;
      layoutAddressOffset += resourceData.totalLength || 0;
    }
    if (value.type === LAYOUT) {
      const themeType = key.split('-')[0]; //themeType看是normal还是aod
      const layoutRecordUid = genId(themeType, LAYOUT);
      const { ref, x, y } = value;
      let resTag = ref.replace('@', '');
      if (resTag.slice(0, 9) === 'AppWidget') {
        resTag = 'Slot' + resTag;
      }
      const resource = resourcesData[resTag];
      if (resource) {
        const { ref: relateRef, type, name } = resource;
        const resourceRecordUid = genId(themeType, type);
        const layoutData: any = {
          type: LAYOUT,
          resUid: resourceRecordUid,
          x,
          y,
          defaultIndex: 0,
          offset: layoutAddressOffset
        };
        // 从 parameter (ref name) 反查 Slot refTable 中的 index
        if (value.parameter && resource.refTable) {
          const idx = resource.refTable.indexOf(value.parameter);
          if (idx >= 0) layoutData.defaultIndex = idx;
        }

        const layoutRecord = {
          type: LAYOUT,
          name,
          uid: layoutRecordUid,
          dataAddress: layoutAddressOffset,
          dataLength: LAYOUT_DATA_PRE_LENGTH
        };

        if (layoutRecordCount === 0) {
          originData.push(layoutData);
        } else {
          const index = originData.findIndex((val, index) => {
            return (
              val.type === LAYOUT &&
              originData[index + 1].type !== LAYOUT &&
              originData.slice(index + 1).findIndex((val) => {
                return val.type === LAYOUT;
              }) === -1
            );
          });
          originData.splice(index + 1, 0, layoutData);
        }

        themeData[themeType].records.push(layoutRecord);
        //每个theme的layout单独计算和记录偏移地址
        layoutAddressOffset += LAYOUT_DATA_PRE_LENGTH;
        layoutRecordCount++;

        let resourceData: any = {};
        const {
          resourceData: newResouceData,
          dataAddressOffset: newAddressOffset
        } = genOriginData(
          type,
          resource,
          relateRef,
          themeType,
          dataAddressOffset
        );
        resourceData = newResouceData;
        // layout全部放在其他资源record之前，所以空出layout个数 * 16的位置存放其他资源record
        if (layoutRecordCount === 1) {
          dataAddressOffset =
            newAddressOffset + (themeData[themeType].layoutsNum || 0) * 16;
        } else if (layoutRecordCount > 1) {
          dataAddressOffset = newAddressOffset;
        }
        if (type === SLOT) {
          const {
            name: slotName,
            includeApps: slotIncludeApps,
            refTable: slotRefTable,
            childrenType
          } = resource;
          const widgetUidTable: Buffer[] = [];
          slotRefTable.forEach((ref: string) => {
            //容器的子集小部件在进行遍历
            const itemTag = ref.replace('@', '');
            const slotItemResource = resourcesData[itemTag];
            const widgetUid = genId(themeType, WIDGET);
            widgetUidTable.push(widgetUid); //小部件的uid
            // 解析widget
            const {
              name: name,
              widgetName: widgetName,
              align: widgetAlign,
              preview: widgetPreview,
              bg: widgetBg,
              bgColor: widgetBgColor,
              posTable: widgetPosTable,
              refTable: widgetRefTable,
              icon: icon,
              editBox: editBox,
              groupType,
              jumpApp
            } = slotItemResource;
            //自定义小部件也包含在slotItemResource里，type为9
            //preview
            let previewRelateUid: 0 | Buffer = 0;
            if (
              widgetPreview &&
              resourcesData[widgetPreview.replace('@', '')]
            ) {
              //这一步主要是拿到对应的图片信息
              const {
                relateRecordUid: previewRelateRecordUid,
                relateData: previewRelateData,
                relateRecord: previewRelateRecord
              } = genRelatedData(
                widgetPreview,
                themeType,
                dataAddressOffset,
                false
              );
              previewRelateUid = previewRelateRecordUid;
              originData.push(previewRelateData);
              themeData[themeType].records.push(previewRelateRecord);
              dataAddressOffset += previewRelateData.totalLength || 0;
            }
            //icon
            let iconRelateUid: 0 | Buffer = 0;
            if (icon && resourcesData[icon.replace('@', '')]) {
              //这一步主要是拿到对应的图片信息
              const {
                relateRecordUid: iconRelateRecordUid,
                relateData: iconRelateData,
                relateRecord: iconRelateRecord
              } = genRelatedData(icon, themeType, dataAddressOffset, false);
              iconRelateUid = iconRelateRecordUid;
              originData.push(iconRelateData);
              themeData[themeType].records.push(iconRelateRecord);
              dataAddressOffset += iconRelateData.totalLength || 0;
            }
            //editBox
            let editBoxRelateUid: 0 | Buffer = 0;
            if (editBox && resourcesData[editBox.replace('@', '')]) {
              //这一步主要是拿到对应的图片信息
              const {
                relateRecordUid: editBoxRelateRecordUid,
                relateData: editBoxRelateData,
                relateRecord: editBoxRelateRecord
              } = genRelatedData(editBox, themeType, dataAddressOffset, false);
              editBoxRelateUid = editBoxRelateRecordUid;
              originData.push(editBoxRelateData);
              themeData[themeType].records.push(editBoxRelateRecord);
              dataAddressOffset += editBoxRelateData.totalLength || 0;
            }
            // bg背景图片
            let bgRelateUid: 0 | Buffer = 0;
            if (widgetBg && resourcesData[widgetBg.replace('@', '')]) {
              const {
                relateRecordUid: bgRelateRecordUid,
                relateData: bgRelateData,
                relateRecord: bgRelateRecord
              } = genRelatedData(widgetBg, themeType, dataAddressOffset, false);
              bgRelateUid = bgRelateRecordUid;
              originData.push(bgRelateData);
              themeData[themeType].records.push(bgRelateRecord);
              dataAddressOffset += bgRelateData.totalLength || 0; //主要是这里的偏移量计算
            }
            const uidTable: Buffer[] = [];
            const dataTable = [];
            if (widgetRefTable.length > 0) {
              //小部件的子集进行遍历，生成UId
              widgetRefTable.forEach((ref: string) => {
                const refTag = ref.replace('@', '');
                const widgetItemResource = resourcesData[refTag];
                if (!widgetItemResource) {
                  return;
                }
                const { type, ref: relateRef } = widgetItemResource;
                const {
                  resourceData: itemData,
                  dataAddressOffset: newAddressOffset
                } = genOriginData(
                  type,
                  widgetItemResource,
                  relateRef,
                  themeType,
                  dataAddressOffset
                );
                dataAddressOffset = newAddressOffset;
                const itemUid = genId(themeType, type);
                uidTable.push(itemUid);
                const record = {
                  type,
                  uid: itemUid,
                  dataAddress: dataAddressOffset,
                  dataLength: itemData.totalLength || 0
                };

                originData.push(itemData);
                themeData[themeType].records.push(record);
                dataAddressOffset += itemData.totalLength || 0;
              });
            }
            for (let i = 0; i < uidTable.length; i++) {
              dataTable.push(
                ...widgetPosTable[i].map((item: any) => uint16(item)),
                uidTable[i]
              );
            }
            let optional: any = [];
            const editdata = editBox && resourcesData[editBox.replace('@', '')];
            const icondata = icon && resourcesData[icon.replace('@', '')];
            if (editdata && icondata) {
              optional = Buffer.alloc(8);
            } else if (!editdata && !icondata) {
              optional = Buffer.alloc(0);
            } else {
              optional = Buffer.alloc(4);
            }
            //optional 计算小部件的可选optional_data属性
            const dataTableBinary = Buffer.concat(dataTable); //全部子集的二进制数据
            const widgetData: any = {
              type: WIDGET,
              name: name,
              align: widgetAlign,
              preview: previewRelateUid,
              icon: iconRelateUid,
              editBox: editBoxRelateUid,
              groupType,
              jumpApp,
              uidBgImg: bgRelateUid,
              bgColor: widgetBgColor,
              posTable: widgetPosTable,
              uidTable,
              totalLength:
                WIDGET_PRE_LENGTH + dataTableBinary.length + optional.length,
              dataTable: dataTableBinary,
              widgetName: widgetName
            };
            const widgetRecord = {
              type: WIDGET,
              uid: widgetUid,
              dataAddress: dataAddressOffset,
              dataLength: widgetData.totalLength || 0
            }; //设置widgetData的总长度为44+dataTable的length
            originData.push(widgetData);
            themeData[themeType].records.push(widgetRecord);
            dataAddressOffset += widgetData.totalLength || 0;
          });
          const dataTable = Buffer.concat(widgetUidTable);

          resourceData = {
            type,
            childrenType,
            name: slotName,
            includeApps: slotIncludeApps,
            widgetUidTable: widgetUidTable,
            widgetUidData: dataTable,
            totalLength: SLOT_PRE_LENGTH + dataTable.length
          };
        }

        // WIDGET直接被layout引用
        if (type === WIDGET) {
          const {
            name: widgetName,
            align: widgetAlign,
            preview: widgetPreview,
            bg: widgetBg,
            bgColor: widgetBgColor,
            posTable: widgetPosTable,
            refTable: widgetRefTable
          } = resource;
          let previewRelateUid: 0 | Buffer = 0;
          if (widgetPreview) {
            const {
              relateRecordUid: previewRelateRecordUid,
              relateData: previewRelateData,
              relateRecord: previewRelateRecord
            } = genRelatedData(
              widgetPreview,
              themeType,
              dataAddressOffset,
              false
            );
            previewRelateUid = previewRelateRecordUid;
            originData.push(previewRelateData);
            themeData[themeType].records.push(previewRelateRecord);
            dataAddressOffset += previewRelateData.totalLength || 0;
          }
          let bgRelateUid: 0 | Buffer = 0;
          if (widgetBg) {
            const {
              relateRecordUid: bgRelateRecordUid,
              relateData: bgRelateData,
              relateRecord: bgRelateRecord
            } = genRelatedData(widgetBg, themeType, dataAddressOffset, false);
            bgRelateUid = bgRelateRecordUid;
            originData.push(bgRelateData);
            themeData[themeType].records.push(bgRelateRecord);
            dataAddressOffset += bgRelateData.totalLength || 0;
          }
          const uidTable: Buffer[] = [];
          const dataTable = [];
          if (widgetRefTable.length > 0) {
            widgetRefTable.forEach((ref: string) => {
              const refTag = ref.replace('@', '');
              const widgetItemResource = resourcesData[refTag];
              const { type, ref: relateRef } = widgetItemResource;
              const {
                resourceData: itemData,
                dataAddressOffset: newAddressOffset
              } = genOriginData(
                type,
                widgetItemResource,
                relateRef,
                themeType,
                dataAddressOffset
              );
              dataAddressOffset = newAddressOffset;
              const itemUid = genId(themeType, type);
              uidTable.push(itemUid);
              const record = {
                type,
                uid: itemUid,
                dataAddress: dataAddressOffset,
                dataLength: itemData.totalLength || 0
              };
              originData.push(itemData);
              themeData[themeType].records.push(record);
              dataAddressOffset += itemData.totalLength || 0;
            });
          }
          for (let i = 0; i < uidTable.length; i++) {
            dataTable.push(
              ...widgetPosTable[i].map((item: any) => uint16(item)),
              uidTable[i]
            );
          }
          const dataBinary = Buffer.concat(dataTable);
          resourceData = {
            type,
            name: widgetName,
            align: widgetAlign,
            preview: previewRelateUid,
            uidBgImg: bgRelateUid,
            bgColor: widgetBgColor,
            posTable: widgetPosTable,
            uidTable,
            totalLength: WIDGET_PRE_LENGTH + dataBinary.length,
            dataTable: dataBinary
          };
        }

        const resourceRecord = {
          type,
          name: `${type}_${name}`,
          uid: resourceRecordUid,
          dataAddress: dataAddressOffset,
          dataLength: resourceData.totalLength || 0
        };

        originData.push(resourceData);
        themeData[themeType].records.push(resourceRecord);
        dataAddressOffset += resourceData.totalLength || 0;
        // 当某一theme中的layout遍历完成后，从下一theme重新开始
        if (layoutRecordCount === themeData[themeType].layoutsNum) {
          layoutAddressOffset = dataAddressOffset;
          layoutRecordCount = 0;
        }
      }
    }
  });
  let themeNum = 0;
  Object.entries(themeData).forEach(([_, value]) => {
    if (value.records.length) {
      themeNum++;
    }
    value.records = sortByUid(value.records);
  });
  const headerBin = genHeaderBinary(themeNum, basicInfo, isEditable, isAOD);

  const dataBin = [genDataBinary(originData)];
  const themeAndRecordBin = await genOldThemeAndRecordBinary(
    themeData,
    themeNum,
    resourcePath
  );

  // 设定preview图片地址
  const prevOffset = HEADER_LENGTH + themeAndRecordBin.length;
  // header 里 preview_img_data_addr 前共有32个字节
  const normalPreviewAddr = (themePreview.get('normal')?.dataAddr ?? 0) + prevOffset;
  headerBin.writeInt32LE(Math.min(normalPreviewAddr, 0x7fffffff) | 0, 32);
  // themetable 里 preview_img_data_addr 前共有4个字节
  let i = 0;
  for (const [key, value] of themePreview) {
    if (key.includes('normal')) {
      // 所有的normal全部修改
      const addr = (value?.dataAddr ?? 0) + prevOffset;
      themeAndRecordBin.writeInt32LE(
        Math.min(addr, 0x7fffffff) | 0,
        4 + getThemeTableLength() * i
      );
      i = isAOD && i == 0 ? i + 2 : i + 1;
    }
  }

  const totalData = Buffer.concat([
    headerBin,
    themeAndRecordBin,
    Buffer.concat(dataBin)
  ]);

  // 清除themeData
  resetThemeData();

  // 清除originData
  originData.length = 0;
  // 清除resourcesData
  for (const key in resourcesData) {
    delete resourcesData[key];
  }

  return totalData;
}

function genOriginData(
  type: number,
  resource: any,
  relateRef: string,
  themeType: string,
  dataAddressOffset: number
) {
  let resourceData: any = {};
  switch (type) {
    case IMG:
      {
        const {
          height,
          width,
          imgData,
          compressMethod,
          fmtIndex,
          name,
          recolorEnable
        } = resource;
        resourceData = {
          type,
          height,
          width,
          imgData,
          dataLength: imgData.length,
          totalLength: IMG_DATA_PRE_LENGTH + imgData.length,
          compressMethod,
          recolorEnable,
          fmtIndex,
          name
        };
      }
      break;
    case SPRITE:
      {
        const { interval, repeatCount } = resource;
        if (relateRef) {
          const { relateRecordUid, relateData, relateRecord } = genRelatedData(
            relateRef,
            themeType,
            dataAddressOffset
          );
          resourceData = {
            type,
            uidImgArray: relateRecordUid,
            delayMs: interval,
            repeatCountBuf: repeatCount,
            totalLength: SPRITE_SIMPLE_DATA_PRE_LEENGTH
          };

          originData.push(relateData);
          themeData[themeType].records.push(relateRecord);
          dataAddressOffset += relateData.totalLength || 0;
        }
      }
      break;
    case DATA:
      {
        const { tag, source } = resource;
        switch (tag) {
          case 'DataItemImageValues':
            {
              const {
                posTable,
                valueTable,
                rotation: imgValuesRotation,
                hasInvalidValueImage
              } = resource;
              if (relateRef) {
                const { relateRecordUid, relateData, relateRecord } =
                  genRelatedData(relateRef, themeType, dataAddressOffset);

                let imgValuesFlags = 0;
                // flags一共两个bit：第0位表示是否有posTable，第一位表示是否有valueTable
                if (posTable.length > 0) {
                  imgValuesFlags |= 0x01;
                }
                if (valueTable.length > 0) {
                  imgValuesFlags |= 0x02;
                }
                if (hasInvalidValueImage) {
                  imgValuesFlags |= 0x07;
                }

                const dataTable = [];
                // data table 根据flags取 01,10,11 三选一
                if (imgValuesFlags === 0x01) {
                  dataTable.push(
                    ...posTable.map((item: number[]) =>
                      Buffer.concat([uint16(item[0]), uint16(item[1])])
                    )
                  );
                } else if (imgValuesFlags === 0x02) {
                  dataTable.push(
                    ...valueTable.map((item: number) => uint32(item))
                  );
                } else if (imgValuesFlags === 0x03) {
                  for (let i = 0; i < posTable.length; i++) {
                    dataTable.push(
                      uint16(posTable[i][0]),
                      uint16(posTable[i][1]),
                      uint32(valueTable[i])
                    );
                  }
                }
                const dataTableBinary = Buffer.concat(dataTable);

                resourceData = {
                  type,
                  uidImgArray: relateRecordUid,
                  dataTable: dataTableBinary,
                  rotation: imgValuesRotation,
                  totalLength:
                    DATA_ITEM_IMAGE_VALUES_PRE_LENGTH + dataTableBinary.length,
                  source,
                  tag,
                  flags: imgValuesFlags
                };

                originData.push(relateData);
                themeData[themeType].records.push(relateRecord);
                dataAddressOffset += relateData.totalLength || 0;
              }
            }
            break;
          case 'DataItemImageNumber':
            // 数字图片相关的转bin
            {
              const {
                totalDigits,
                decimalDigits,
                align,
                leadingZero,
                trailingZero,
                unitIcon,
                rotation: imgNumberRotation,
                space
              } = resource;

              if (relateRef) {
                const { relateRecordUid, relateData, relateRecord } =
                  genRelatedData(relateRef, themeType, dataAddressOffset);

                originData.push(relateData);
                themeData[themeType].records.push(relateRecord);
                dataAddressOffset += relateData.totalLength || 0;

                let unitIconUid: 0 | Buffer = 0;
                if (unitIcon) {
                  const {
                    relateRecordUid: unitIconRecordUid,
                    relateData: unitIconData,
                    relateRecord: unitIconRecord
                  } = genRelatedData(
                    unitIcon,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                  unitIconUid = unitIconRecordUid;

                  originData.push(unitIconData);
                  themeData[themeType].records.push(unitIconRecord);
                  dataAddressOffset += unitIconData.totalLength || 0;
                }

                resourceData = {
                  type,
                  uidImgArray: relateRecordUid,
                  totalDigits,
                  decimalDigits,
                  align,
                  leadingZero,
                  trailingZero,
                  unitIcon: unitIconUid,
                  rotation: imgNumberRotation,
                  totalLength: DATA_ITEM_IMAGE_NUMBER_PRE_LENGTH,
                  space,
                  tag,
                  source
                };
              }
            }
            break;
          case 'DataItemPointer':
            {
              const {
                pivotX,
                pivotY,
                angleStart,
                valueStart,
                angleRange,
                valueRange,
                parameter
              } = resource;
              if (relateRef) {
                const { relateRecordUid, relateData, relateRecord } =
                  genRelatedData(
                    relateRef,
                    themeType,
                    dataAddressOffset,
                    false
                  );
                resourceData = {
                  type,
                  uidImg: relateRecordUid,
                  pivotX,
                  pivotY,
                  angleStart,
                  valueStart,
                  angleRange,
                  valueRange,
                  parameter,
                  totalLength: DATA_ITEM_POINTER_DATA_PER_LENGTH,
                  tag,
                  source
                };

                originData.push(relateData);
                themeData[themeType].records.push(relateRecord);
                dataAddressOffset += relateData.totalLength || 0;
              }
            }
            break;
          case 'DataItemArcProgressBar':
            {
              const {
                bg: arcBgRef,
                pivotX: arcPivotX,
                pivotY: arcPivotY,
                angleStart: arcAngleStart,
                valueStart: arcValueStart,
                angleRange: arcAngleRange,
                valueRange: arcValueRange,
                barRadius: arcBarRadius,
                barWidth: arcBarWidth,
                endingStyle: arcEndingStyle,
                indicatorImage: arcIndicatorImage,
                indicatorRadius: arcIndicatorRaius
              } = resource;
              if (relateRef) {
                const { relateRecordUid, relateData, relateRecord } =
                  genRelatedData(
                    relateRef,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                originData.push(relateData);
                themeData[themeType].records.push(relateRecord);
                dataAddressOffset += relateData.totalLength || 0;

                let bgRelateUid: 0 | Buffer = 0;
                if (arcBgRef) {
                  const {
                    relateRecordUid: bgRelateRecordUid,
                    relateData: bgRelateData,
                    relateRecord: bgRelateRecord
                  } = genRelatedData(
                    arcBgRef,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                  bgRelateUid = bgRelateRecordUid;

                  originData.push(bgRelateData);
                  themeData[themeType].records.push(bgRelateRecord);
                  dataAddressOffset += bgRelateData.totalLength || 0;
                }

                let indicatorRelateUid: 0 | Buffer = 0;
                if (arcIndicatorImage) {
                  const {
                    relateRecordUid: indicatorRelateRecordUid,
                    relateData: indicatorRelateData,
                    relateRecord: indicatorRelateRecord
                  } = genRelatedData(
                    arcIndicatorImage,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                  indicatorRelateUid = indicatorRelateRecordUid;
                  originData.push(indicatorRelateData);
                  themeData[themeType].records.push(indicatorRelateRecord);
                  dataAddressOffset += indicatorRelateData.totalLength || 0;
                }

                resourceData = {
                  type,
                  uidFgImg: relateRecordUid,
                  uidBgImg: bgRelateUid,
                  pivotX: arcPivotX,
                  pivotY: arcPivotY,
                  angleStart: arcAngleStart,
                  valueStart: arcValueStart,
                  angleRange: arcAngleRange,
                  valueRange: arcValueRange,
                  barRadius: arcBarRadius,
                  barWidth: arcBarWidth,
                  endingStyle: arcEndingStyle,
                  indicatorImage: arcIndicatorImage,
                  uidIndicatorImg: indicatorRelateUid,
                  indicatorRadius: arcIndicatorRaius,
                  tag,
                  source,
                  totalLength: DATA_ITEM_ARC_PROGRESS_BAR_INDICATOR_PRE_LENGTH
                  // totalLength: arcIndicatorImage
                  //   ? DATA_ITEM_ARC_PROGRESS_BAR_INDICATOR_PRE_LENGTH
                  //   : DATA_ITEM_ARC_PROGRESS_BAR_PRE_LENGTH,
                };
              }
            }
            break;
          case 'DataItemLineProgressBar':
            {
              const {
                bg: lineBgRef,
                barWidth: lineBarWidth,
                startX: lineStartX,
                startY: lineStartY,
                endX: lineEndX,
                endY: lineEndY,
                valueStart: lineValueStart,
                valueRange: lineValueRange,
                endingStyle: lineEndingStyle,
                indicatorImage: lineIndicatorImage,
                indicatorOffsetX: lineIndicatorOffsetX,
                indicatorOffsetY: lineIndicatorOffsetY
              } = resource;
              if (relateRef) {
                const { relateRecordUid, relateData, relateRecord } =
                  genRelatedData(
                    relateRef,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                originData.push(relateData);
                themeData[themeType].records.push(relateRecord);
                dataAddressOffset += relateData.totalLength || 0;

                let bgRelateUid: 0 | Buffer = 0;
                if (lineBgRef) {
                  const {
                    relateRecordUid: bgRelateRecordUid,
                    relateData: bgRelateData,
                    relateRecord: bgRelateRecord
                  } = genRelatedData(
                    lineBgRef,
                    themeType,
                    dataAddressOffset,
                    false
                  );

                  bgRelateUid = bgRelateRecordUid;

                  originData.push(bgRelateData);
                  themeData[themeType].records.push(bgRelateRecord);
                  dataAddressOffset += bgRelateData.totalLength || 0;
                }

                let indicatorRelateUid: 0 | Buffer = 0;
                if (lineIndicatorImage) {
                  const {
                    relateRecordUid: indicatorRelateRecordUid,
                    relateData: indicatorRelateData,
                    relateRecord: indicatorRelateRecord
                  } = genRelatedData(
                    lineIndicatorImage,
                    themeType,
                    dataAddressOffset,
                    false
                  );
                  indicatorRelateUid = indicatorRelateRecordUid;
                  originData.push(indicatorRelateData);
                  themeData[themeType].records.push(indicatorRelateRecord);
                  dataAddressOffset += indicatorRelateData.totalLength || 0;
                }

                resourceData = {
                  type,
                  uidFgImg: relateRecordUid,
                  uidBgImg: bgRelateUid,
                  barWidth: lineBarWidth,
                  startX: lineStartX,
                  startY: lineStartY,
                  endX: lineEndX,
                  endY: lineEndY,
                  valueStart: lineValueStart,
                  valueRange: lineValueRange,
                  endingStyle: lineEndingStyle,
                  indicatorImage: lineIndicatorImage,
                  uidIndicatorImage: indicatorRelateUid,
                  indicatorOffsetX: lineIndicatorOffsetX,
                  indicatorOffsetY: lineIndicatorOffsetY,
                  tag,
                  source,
                  totalLength: DATA_ITEM_LINE_PROGRESS_BAR_INDICATOR_PRE_LENGTH
                };
              }
            }
            break;
          default:
            break;
        }
      }
      break;
    default:
      break;
  }
  return { resourceData, dataAddressOffset };
}

function genDataBinary(data: any) {
  const dataBin: Buffer[] = [];
  try {
    data.forEach((item: any) => {
      const { type, compressMethod, recolorEnable } = item;
      console.log(item, 'item', Buffer.concat(dataBin).length);
      //0是layout 2是img 9是widget 8是slot
      switch (type) {
        case IMG:
          {
            const imgBin = Buffer.concat([
              uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex), // fmt
              uint8(
                ((compressMethod === 'RLEReversed'
                  ? 1
                  : compressMethod === 'RLE'
                  ? 2
                  : 0) <<
                  2) +
                  (recolorEnable === 'true' ? 1 : 0)
              ), // 是否压缩
              uint16(0), // reserved
              uint16(item.width),
              uint16(item.height),
              uint32(item.dataLength),
              item.imgData
            ]);
            dataBin.push(imgBin);
          }
          break;
        case LAYOUT:
          {
            const defaultIndex = Number(item.defaultIndex || 0);
            const layoutBin = Buffer.concat([
              item.resUid,
              uint16(item.x || 0),
              uint16(item.y || 0),
              uint32(defaultIndex), //parameter: bit[7:0]为默认展示项index，bit[31:8] reserved
              uint32(0) //reserved
            ]);
            dataBin.push(layoutBin);
          }
          break;
        case IMG_ARRAY:
          {
            const fmt = uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex);
            const imgNumber = uint8(item.imgNumber);
            const flag = uint16(
              ((compressMethod === 'RLEReversed'
                ? 1
                : compressMethod === 'RLE'
                ? 2
                : 0) <<
                2) +
                (recolorEnable === 'true' ? 1 : 0)
            );
            const imgWidth = uint16(item.width);
            const imgHeight = uint16(item.height);
            let imgInfo = Buffer.concat([]);
            const imgData = item.imgData;
            const imgLengthInfo = item.imgLengthInfo as number[];
            if (imgLengthInfo && compressMethod && compressMethod !== 'None') {
              //当存在包含图片长度的数组并且 有压缩方式并且压缩方式不等于None，就去计算imgInfo的长度
              imgLengthInfo.forEach((len) => {
                imgInfo = Buffer.concat([imgInfo, uint32(len)]);
              });
              // item.dataLength += imgInfo.length; //dataLength包含总长度
            }
            const dataLength = uint32(item.dataLength);
            const imgArrBin = Buffer.concat([
              fmt,
              imgNumber,
              flag,
              imgWidth,
              imgHeight,
              dataLength,
              imgInfo,
              imgData
            ]);
            dataBin.push(imgArrBin);
          }
          break;

        case SPRITE:
          {
            const imgArrUid = item.uidImgArray;
            // imgNumber 改为保留字段
            const imgNum = uint8(0);
            // flags=1表示复杂动画，目前不支持复杂动画
            const flags = uint8(0);
            const delayMs = uint16(item.delayMs);
            const repeatCount = uint32(item.repeatCountBuf);

            const spriteBin = Buffer.concat([
              imgArrUid,
              imgNum,
              flags,
              delayMs,
              repeatCount
            ]);
            dataBin.push(spriteBin);
          }
          break;

        case DATA:
          {
            const { tag } = item;
            switch (tag) {
              case 'DataItemImageValues':
                {
                  const imgValuesSourceId = uint16(dataItemStyle[item.source]);
                  const imgValuesDigits = uint8(0);
                  const imgValuesFlags = uint8((2 << 4) + 0);
                  const imgValuesPrivate = uint32(0);
                  const imgValuesRecordBinary = Buffer.concat([
                    imgValuesSourceId,
                    imgValuesDigits,
                    imgValuesFlags,
                    imgValuesPrivate
                  ]);

                  const imgValuesImgArrUid = item.uidImgArray;
                  const imgValuesReserved = uint8(0);
                  const tableFlags = uint8(item.flags);
                  const imgValuesRotation = uint16(item.rotation);
                  const dataTable = item.dataTable;
                  const imgValuesDataStyleBinary = Buffer.concat([
                    imgValuesImgArrUid,
                    imgValuesReserved,
                    tableFlags,
                    imgValuesRotation,
                    dataTable
                  ]);

                  const imgValuesDataBinary = Buffer.concat([
                    imgValuesRecordBinary,
                    imgValuesDataStyleBinary
                  ]);
                  dataBin.push(imgValuesDataBinary);
                }
                break;

              case 'DataItemImageNumber':
                {
                  const imgNumSourceId = uint16(dataItemStyle[item.source]);
                  // digits中 3:0总位数 7:4小数位数
                  const imgNumDigits = uint8(
                    (item.decimalDigits << 4) + item.totalDigits
                  );
                  // 1:0 00右 01左 10中
                  let alignFlag = 0;
                  if (item.align === 'right') {
                    alignFlag = 0;
                  } else if (item.align === 'left') {
                    alignFlag = 1;
                  } else if (item.align === 'center') {
                    alignFlag = 2;
                  }
                  const leadingZeroFlag = item.leadingZero === 'true' ? 1 : 0;
                  const trailingZeroFlag = item.trailingZero === 'true' ? 1 : 0;
                  const imgNumFlags = uint8(
                    (1 << 4) +
                      (trailingZeroFlag << 3) +
                      (leadingZeroFlag << 2) +
                      alignFlag
                  );
                  const imgNumPrivate = uint32(0);
                  const imgNumRecordBinary = Buffer.concat([
                    imgNumSourceId,
                    imgNumDigits,
                    imgNumFlags,
                    imgNumPrivate
                  ]);

                  const imgNumImgArrUid = item.uidImgArray;
                  const imgNumreserved = uint8(0);
                  const space = int8(item.space);
                  const imgNumRotation = uint16(item.rotation * 10);
                  const uidUnitIcon = item.unitIcon ? item.unitIcon : uint32(0);
                  const imgNumDataStyleBinary = Buffer.concat([
                    imgNumImgArrUid,
                    imgNumreserved,
                    space,
                    imgNumRotation,
                    uidUnitIcon
                  ]);

                  const imgNumDataBinary = Buffer.concat([
                    imgNumRecordBinary,
                    imgNumDataStyleBinary
                  ]);
                  dataBin.push(imgNumDataBinary);
                }
                break;
              case 'DataItemPointer':
                {
                  const dataRecordBinary = Buffer.concat([
                    uint16(dataItemStyle[item.source]),
                    uint8(0), // digits
                    uint8(0b00110000), //private
                    // uint32(0),
                    uint16(0),
                    uint16(Number(item.parameter))
                  ]);

                  const valueStartB = int32(item.valueStart * 256);
                  const valueRangeB = int32(item.valueRange * 256);
                  const centorXB = int16(item.pivotX);
                  const centorYB = int16(item.pivotY);
                  const angleStartB = int16(item.angleStart * 10);
                  const angleRangeB = int16(item.angleRange * 10);
                  const reserved = uint32(0);
                  // const parameter = uint16(0);
                  const dataStyleBinary = Buffer.concat([
                    item.uidImg,
                    valueStartB,
                    valueRangeB,
                    centorXB,
                    centorYB,
                    angleStartB,
                    angleRangeB,
                    reserved
                    // parameter,
                  ]);

                  const dataBinary = Buffer.concat([
                    dataRecordBinary,
                    dataStyleBinary
                  ]);
                  dataBin.push(dataBinary);
                }

                break;
              case 'DataItemArcProgressBar':
                {
                  const arcSourceId = uint16(dataItemStyle[item.source]);
                  const arcDigits = uint8(0);
                  const arcFlags = uint8((4 << 4) + 0);
                  const arcPrivate = uint32(0);
                  const arcRecordBinary = Buffer.concat([
                    arcSourceId,
                    arcDigits,
                    arcFlags,
                    arcPrivate
                  ]);

                  const fgImgUid = item.uidFgImg;
                  const bgImgUid = item.uidBgImg ? item.uidBgImg : uint32(0);
                  const arcLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
                  const arcPointerFlag = item.uidIndicatorImg ? 1 : 0;
                  const arcStyleFlags = uint32(
                    (arcPointerFlag << 1) + arcLineCapFlag
                  );
                  const arcValueStart = int32(item.valueStart * 256);
                  const arcValueRange = int32(item.valueRange * 256);
                  const arcCentorX = int16(item.pivotX);
                  const arcCentorY = int16(item.pivotY);
                  const arcAngleStart = int16(item.angleStart * 10);
                  const arcAngleRange = int16(item.angleRange * 10);
                  const arcBarRadius = int16(item.barRadius);
                  const arcBarWidth = int16(item.barWidth);

                  const indicator = [];
                  // 是否有indicator，指示器结构都要存在，无则数据置0
                  const arcIndicatorImgUid = arcPointerFlag
                    ? item.uidIndicatorImg
                    : uint32(0);
                  const arcIndicatorRadius = arcPointerFlag
                    ? int16(item.indicatorRadius)
                    : int16(0);
                  const reserved1 = int16(0);
                  const reserved2 = uint32(0);
                  indicator.push(
                    arcIndicatorImgUid,
                    arcIndicatorRadius,
                    reserved1,
                    reserved2
                  );
                  const indicatorBinary = Buffer.concat(indicator);
                  const arcDataStyleBinary = Buffer.concat([
                    fgImgUid,
                    bgImgUid,
                    arcStyleFlags,
                    arcValueStart,
                    arcValueRange,
                    arcCentorX,
                    arcCentorY,
                    arcAngleStart,
                    arcAngleRange,
                    arcBarRadius,
                    arcBarWidth,

                    indicatorBinary
                  ]);
                  const arcDataBinary = Buffer.concat([
                    arcRecordBinary,
                    arcDataStyleBinary
                  ]);
                  dataBin.push(arcDataBinary);
                }
                break;
              case 'DataItemLineProgressBar':
                {
                  const lineSourceId = uint16(dataItemStyle[item.source]);
                  const lineDigits = uint8(0);
                  const lineFlags = uint8((5 << 4) + 0);
                  const linePrivate = uint32(0);
                  const lineRecordBinary = Buffer.concat([
                    lineSourceId,
                    lineDigits,
                    lineFlags,
                    linePrivate
                  ]);

                  const linefgImgUid = item.uidFgImg;
                  const lineBgImgUid = item.uidBgImg
                    ? item.uidBgImg
                    : uint32(0);
                  const lineLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
                  const linePointerFlag = item.uidIndicatorImg ? 1 : 0;
                  const lineStyleFlags = uint32(
                    (linePointerFlag << 1) + lineLineCapFlag
                  );
                  const lineValueStart = int32(item.valueStart * 256);
                  const lineValueRange = int32(item.valueRange * 256);
                  const lineStartX = int16(item.startX);
                  const lineStartY = int16(item.startY);
                  const lineEndX = int16(item.endX);
                  const lineEndY = int16(item.endY);
                  const lineReserved = uint16(0);
                  const lineBarWidth = uint16(item.barWidth);

                  const lineIndicator = [];
                  const lineIndicatorImgUid = linePointerFlag
                    ? item.uidIndicatorImage
                    : uint32(0);
                  const lineOffsetX = linePointerFlag
                    ? int16(item.indicatorOffsetX)
                    : int16(0);
                  const lineOffsetY = linePointerFlag
                    ? int16(item.indicatorOffsetY)
                    : int16(0);
                  const lineReserved2 = uint32(0);
                  lineIndicator.push(
                    lineIndicatorImgUid,
                    lineOffsetX,
                    lineOffsetY,
                    lineReserved2
                  );
                  const lineIndicatorBinary = Buffer.concat(lineIndicator);
                  const lineDataStyleBinary = Buffer.concat([
                    linefgImgUid,
                    lineBgImgUid,
                    lineStyleFlags,
                    lineValueStart,
                    lineValueRange,
                    lineStartX,
                    lineStartY,
                    lineEndX,
                    lineEndY,
                    lineReserved,
                    lineBarWidth,
                    lineIndicatorBinary
                  ]);
                  const lineDataBinary = Buffer.concat([
                    lineRecordBinary,
                    lineDataStyleBinary
                  ]);
                  dataBin.push(lineDataBinary);
                }
                break;
              default:
                break;
            }
          }
          break;
        case WIDGET:
          {
            const widgetName = Buffer.alloc(32); //创建一个长度为32的空buffer
            if (item.widgetName) {
              widgetName.write(item.widgetName);
            }
            let widgetBg;
            if (item.uidBgImg) {
              widgetBg = item.uidBgImg;
            } else if (item.bgColor) {
              //如果存在bgColor的话
              widgetBg = uint32(item.bgColor);
            } else {
              widgetBg = uint32(0);
            }
            const uidIconImg = item.icon; //icon
            const uidEditBoxImg = item.editBox; //editBox
            const widgetUidPreviewImg = item.preview; //预览图
            const widgetRecordCount = uint8(item.uidTable.length);
            const binGroupType = enumGroupType.findIndex((id) => {
              return id === item.groupType;
            });
            let groupType = uint8(0); //对应groupType
            if (binGroupType > -1) {
              groupType = uint8(binGroupType);
            }
            const bgFlag = item.uidBgImg ? 0 : 1;
            const enableJumpFlag = 0;
            let widgetFlags = (enableJumpFlag << 1) + bgFlag;
            let appId = '0x0';
            let index = 0;
            if (
              (index = app_id.findIndex(
                (id) => item.jumpApp === id.split('@')[0]
              )) > -1
            ) {
              appId = app_id[index].split('@')[1];
            }
            widgetFlags = item.jumpApp ? widgetFlags + 0x2 : widgetFlags & ~0x2;
            widgetFlags = uidEditBoxImg
              ? widgetFlags + 0x4
              : widgetFlags & ~0x4;
            widgetFlags = uidIconImg ? widgetFlags + 0x8 : widgetFlags & ~0x8;
            widgetFlags = (widgetFlags & ~0x3f0) + (Number(appId) << 0x4);

            const widgetRecordTable = item.dataTable;
            const widgetDataBinary = Buffer.concat([
              widgetName,
              widgetBg,
              widgetUidPreviewImg ? widgetUidPreviewImg : uint32(0),
              widgetRecordCount,
              groupType,
              uint16(widgetFlags),
              widgetRecordTable,
              uidEditBoxImg ? uidEditBoxImg : Buffer.alloc(0),
              uidIconImg ? uidIconImg : Buffer.alloc(0)
            ]);

            dataBin.push(widgetDataBinary);
          }
          break;
        case SLOT:
          {
            const widgetCount = uint8(item.widgetUidTable.length);
            const slotReserved = uint8(0);
            let slotFlags = uint16(0);
            if (item.childrenType == 'time') {
              slotFlags = uint16(1 << 4);
            } else if (item.childrenType == 'dial') {
              slotFlags = uint16(2 << 4);
            } else if (item.childrenType === 'appWidget') {
              slotFlags = uint16(3 << 4);
            }
            const slotUidWidgets = item.widgetUidData;
            const slotDataBinary = Buffer.concat([
              widgetCount,
              slotReserved,
              slotFlags,
              slotUidWidgets
            ]);
            dataBin.push(slotDataBinary);
          }
          break;
        default:
          break;
      }
    });
  } catch (error) {
    console.log(error, '错误的error处理');
  }

  return Buffer.concat(dataBin);
}

function genRelatedData(
  relateRef: string,
  themeType: string,
  dataAddressOffset: number,
  isArray = true
) {
  //图片获取二进制流程
  const relateTag = relateRef.replace('@', '');
  const relate = resourcesData[relateTag];
  const {
    type: relateType,
    imgNumber: relateImgNumber, //不存在
    height: relateHeight,
    width: relateWidth,
    imgData: relateImgData,
    name,
    imgLengthInfo: relateImgLengthInfo, //不存在
    compressMethod,
    recolorEnable
  } = relate;
  const relateRecordUid: Buffer = genId(themeType, relateType);
  let recordLength = 0; //计算当前record的总长度
  if (isArray) {
    recordLength =
      compressMethod !== 'None' && compressMethod
        ? IMG_ARRY_DATA_PRE_LENGTH + relateImgNumber * 4 + relateImgData.length
        : IMG_ARRY_DATA_PRE_LENGTH + relateImgData.length;
  } else {
    recordLength = IMG_DATA_PRE_LENGTH + relateImgData.length;
  }
  const relateData: any = {
    type: relateType,
    imgNumber: relateImgNumber,
    height: relateHeight,
    width: relateWidth,
    imgData: relateImgData,
    dataLength: relateImgData.length,
    totalLength: recordLength,
    imgLengthInfo: relateImgLengthInfo,
    recolorEnable
  };
  relateData.compressMethod = relate.compressMethod;
  relateData.fmtIndex = relate.fmtIndex;
  const relateRecord = {
    type: relateType,
    name,
    uid: relateRecordUid,
    dataAddress: dataAddressOffset,
    dataLength: relateData.totalLength || 0
  };

  return {
    relateRecordUid,
    relateData,
    relateRecord
  };
}

function genId(themeType: string, recordType: number) {
  themeData[themeType].recordsCount[recordType]++;
  const uid = Buffer.alloc(4);
  const adder = themeData[themeType].recordsIdAdder[recordType];
  if (adder > 0xffffff) {
    console.warn(`[BIN] genId overflow: recordsIdAdder[${recordType}] = ${adder}, exceeds 24-bit limit`);
  }
  uid.writeUInt32LE(Math.min(adder, 0xffffffff) >>> 0, 0);
  uid.writeUInt8(recordType & 0xff, 3);
  themeData[themeType].recordsIdAdder[recordType]++;
  return uid;
}

function sortByUid(records: any) {
  return records.sort((a: any, b: any) => {
    const uid_a = a.uid[0] + (a.uid[1] << 8) + (a.uid[2] << 16);
    const uid_b = b.uid[0] + (b.uid[1] << 8) + (b.uid[2] << 16);
    return a.uid[3] < b.uid[3] || (a.uid[3] === b.uid[3] && uid_a < uid_b)
      ? -1
      : 1;
  });
}
const imgTypeListConvert: any = {
  truecolor_alpha: 'argb8888',
  truecolor: 'xrgb8888',
  alpha8: 'alpha8',
  indexed8: 'indexed8',
  rgb565: 'rgb565',
  argb4444: 'argb4444'
};

async function genImageData(
  resource: Ast,
  xmlPath: string,
  watchCompressMethod?: string
) {
  const {
    name,
    src: originSrc,
    compressMethod,
    format,
    recolorEnable
  } = resource.attrsMap;
  const imgFormat = imgTypeListConvert[format];
  const compress = (
    watchCompressMethod &&
    watchCompressMethod !== 'None' &&
    watchCompressMethod !== ''
      ? watchCompressMethod
      : compressMethod === '' || compressMethod === 'None'
      ? undefined
      : compressMethod
  ) as CompressMethod;
  const src = path?.resolve(xmlPath, `${originSrc}`) ?? '';
  const size = await getImageSize(src);
  const width = size?.width || 0;
  const height = size?.height || 0;
  // 替换
  const imgData = await pngConvert(src, imgFormat, compress, false);
  const fmtIndex = imgFormat ? fmtIndexEnum[imgFormat] || 0 : 0;
  return {
    type: IMG,
    name,
    src,
    width,
    height,
    imgData,
    compressMethod: compress,
    fmtIndex,
    recolorEnable
  };
}

async function genImageArrayData(
  imgArray: Ast,
  xmlPath: string,
  watchCompressMethod?: string
) {
  let width: number | undefined = 0;
  let height: number | undefined = 0;
  const { name, compressMethod, format, recolorEnable } = imgArray.attrsMap;
  const data = [];
  const imgFormat = imgTypeListConvert[format];
  const compress = (
    watchCompressMethod &&
    watchCompressMethod !== 'None' &&
    watchCompressMethod !== ''
      ? watchCompressMethod
      : compressMethod === '' || compressMethod === 'None'
      ? undefined
      : compressMethod
  ) as CompressMethod;
  for (let index = 0; index < imgArray.children.length; index++) {
    const img = imgArray.children[index];
    const { src: originSrc } = img.attrsMap;
    const src = path?.resolve(xmlPath, `${originSrc}`);

    // 获取第一张图片宽高
    if (index === 0) {
      const size = await getImageSize(src);
      width = size?.width || 0;
      height = size?.height || 0;
    }

    if (src) {
      const dataItem = (await pngConvert(
        src,
        imgFormat,
        compress,
        false
      )) as Buffer;
      data.push(dataItem);
    }
  }
  const imgLengthInfo = data.map((i) => i.length); //含单个图片长度的数组

  const imgData = Buffer.concat(data);
  const imgNumber = imgArray.children.length;

  const fmtIndex = imgFormat ? fmtIndexEnum[imgFormat] || 0 : 0;

  return {
    type: IMG_ARRAY,
    imgNumber,
    width,
    height,
    name,
    imgData,
    imgLengthInfo,
    compressMethod,
    fmtIndex,
    recolorEnable
  };
}
// function genDataItemValuesData(params) {}
function genSimpleData(resource: Ast, type: number) {
  //Sprite, DataItemImageNumber, DataItemPointer
  return { type, ...resource.attrsMap, tag: resource.tag };
}

function genLayoutData(layout: any) {
  return {
    type: LAYOUT,
    ...layout.attrsMap
  };
}

function genDataItemValuesData(imgValues: Ast) {
  const { name, source, ref, rotation } = imgValues.attrsMap;

  // 计算position table和value table
  const posTable: number[][] = [];
  const valueTable: number[] = [];
  const { children } = imgValues;

  if (children && children.length > 0) {
    children.forEach((item: any) => {
      const { value, offsetX, offsetY } = item.attrsMap;
      if (value) {
        valueTable.push(value);
      }
      if (offsetX || offsetY) {
        posTable.push([offsetX || 0, offsetY || 0]);
      }
    });
  }

  return {
    type: DATA,
    name,
    source,
    ref,
    rotation,
    posTable,
    valueTable,
    tag: imgValues.tag
  };
}

function genWidgetData(widget: any) {
  //attrsMap就是之前挂载的哪些内容
  const {
    name,
    align,
    preview,
    bg,
    bgColor,
    jumpApp,
    icon,
    editBox,
    groupType,
    widgetName
  } = widget.attrsMap;
  //注意xml从attrsMap的获取，是否漏了元素
  // 计算内部item元素
  const { children } = widget;
  const posTable: number[][] = [];
  const refTable: string[] = [];
  children.forEach((item: any) => {
    const { x, y, ref } = item.attrsMap;
    posTable.push([x, y]);
    refTable.push(ref);
  });
  return {
    type: WIDGET,
    name,
    align,
    preview,
    bg,
    bgColor,
    posTable,
    refTable,
    //针对其他类型进行属性的抛出
    jumpApp,
    icon,
    editBox,
    groupType,
    widgetName
  };
}

function genSlotData(slot: any) {
  const { name, includeApps, type } = slot.attrsMap;
  const { children } = slot;
  const refTable: string[] = [];
  children.forEach((item: any) => {
    const { ref } = item.attrsMap;
    refTable.push(ref);
  });
  return {
    type: SLOT,
    childrenType: type,
    name,
    includeApps,
    refTable
  };
}

function genHeaderBinary(
  themeNum: number,
  basicInfo: Description,
  isEditable: boolean,
  isAOD: boolean
) {
  const {
    version,
    editorVersion: romVersion,
    pkgName,
    name: watchName,
    recolorTable: recolors
  } = basicInfo;
  const magicWord = uint32(0x1234a55a);
  const watchFaceVerision = version ? parseVersion(version) : 0;
  const firmWareVersion = romVersion ? parseVersion(romVersion) : 0;

  const watchface = uint32(watchFaceVerision);
  const editor = uint32(0);
  const generator = uint32(0);
  const protocol = uint32(0x00000800);
  const versionFirmware = uint32(firmWareVersion);

  const checksum = uint32(0); //在6.0.3中删除
  const themeCount = uint8(themeNum);
  const defaultTheme = uint8(recolors ? recolors.split(',').length : 0); //在6.0.3中删除

  const isAlbum = themeData['normal'].isPhotoAlbumWatchface;
  const bgFlag = isAlbum === 'true' ? 1 : 0;
  const leftFlag = 0;
  let flags = (leftFlag << 1) + bgFlag; //设置flags的0bit判断是否是相册表盘
  flags = isEditable ? flags + 0x2 : flags & ~0x2; // 设置flags的1bit 是否editable
  flags = isAOD === true ? flags + 0x4 : flags & ~0x4; //设置flags的2bit 是否是aod
  const previewImgDataAddr = uint32(248);
  const reserved = uint32(0);
  const id = Buffer.alloc(64);
  const name = Buffer.alloc(64);
  const recolorsArr = recolors ? recolors.split(',') : [];

  if (pkgName) id.write(pkgName);
  if (watchName) name.write(watchName);
  let recolorTable;
  if (recolorsArr.length > 0) {
    recolorTable = uint32(
      parseInt(recolorsArr[0].replace(new RegExp('#', 'g'), '00'), 16)
    );
    if (recolorsArr.length > 1) {
      for (let i = 1; i < recolorsArr.length; i++) {
        recolorTable = Buffer.concat([
          recolorTable,
          uint32(
            parseInt(recolorsArr[i].replace(new RegExp('#', 'g'), '00'), 16)
          )
        ]);
      }
    }
  }
  let newBuf = Buffer.concat([
    magicWord,
    watchface,
    editor,
    generator,
    protocol,
    versionFirmware,
    checksum, // reserved
    themeCount,
    defaultTheme, // color_count
    uint16(flags),
    previewImgDataAddr,
    reserved,

    id,
    name
  ]);
  if (recolorTable) {
    newBuf = Buffer.concat([newBuf, recolorTable]);
  }
  return newBuf;
}

export async function genOldThemeAndRecordBinary(
  themeData: any,
  themeNum: number,
  xmlPath?: string
) {
  let totalRecordNum = 0;
  const themePreLength = getThemePreLength();
  const recordStartAddr = HEADER_LENGTH + themeNum * themePreLength;
  let recordsOffset = 0;
  const themeTableArr = Object.entries(themeData).map(
    ([themeType, value]: [string, any]) => {
      if (!value.records.length) return Buffer.alloc(0);
      totalRecordNum += value.records.length;
      const themeTable = Buffer.alloc(getThemeTableLength());
      // v0.70 新增bgColor，previewImgDataAddr字段
      let bgColor = 0;
      if (value.bgColor) bgColor = Number(`0x${value.bgColor.slice(1)}`);
      themeTable.writeUInt32LE(bgColor, 0);

      for (let i = 0; i < getThemeTableTotalCount(); i++) {
        const adder = Math.min(value.recordsIdAdder[i], 0xffffffff) >>> 0;
        themeTable.writeUInt32LE(
          adder,
          i * THEME_TABLE_PER_ROW_LENGTH + THEME_TABLE_PRE_LENGTH
        );
        const addr = Math.min(recordStartAddr + recordsOffset, 0xffffffff) >>> 0;
        themeTable.writeUInt32LE(
          addr,
          i * THEME_TABLE_PER_ROW_LENGTH + 4 + THEME_TABLE_PRE_LENGTH
        );
        recordsOffset += value.recordsIdAdder[i] * RECORD_LENGTH;
      }
      return themeTable;
    }
  );

  const dataOffset =
    HEADER_LENGTH + themeNum * themePreLength + totalRecordNum * RECORD_LENGTH;

  const recordsArr: Buffer[] = [];
  const nameArr: string[] = [];
  const uidArr: any[] = [];
  Object.entries(themeData).forEach(([key, value]: [string, any]) => {
    value.records.forEach((record: any) => {
      if (record.type !== 0) {
        const name = record.name;
        if (!nameArr.includes(name) || record.colorGroup) {
          const mapUid = Buffer.from(record.uid)
            .reverse()
            .toString('hex')
            .slice(1);
          nameArr.push(name);
          uidArr.push(mapUid);
        }
      }
      const flags = uint32(0);
      const dataAddress = uint32(record.dataAddress + dataOffset);
      const dataLength = uint32(record.dataLength);
      const recordBin = Buffer.concat([
        record.uid,
        flags,
        dataAddress,
        dataLength
      ]);
      recordsArr.push(recordBin);
    });
  });

  xmlPath && (await saveMap(xmlPath, nameArr, uidArr));
  return Buffer.concat([...themeTableArr, ...recordsArr]);
}

export default m65m66XmlConvert;
